import { LearnerLessonType, ProductCategoryType } from "@hubcapp/types";

export const learnerLessonTypeToProductCategoryType = (
  lessonType: LearnerLessonType,
): ProductCategoryType => {
  switch (lessonType) {
    case LearnerLessonType.Standard:
      return ProductCategoryType.PreTest;
    case LearnerLessonType.Motability:
      return ProductCategoryType.Motability;
    case LearnerLessonType.Motorway:
      return ProductCategoryType.PostTest;
    case LearnerLessonType.PassPlus:
      return ProductCategoryType.PostTest;
    case LearnerLessonType.Qualified:
      return ProductCategoryType.PostTest;
    case LearnerLessonType.Dit:
      return ProductCategoryType.Dit;
  }
};
